import { Modal, Button } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}

export const ModalInfoLogin: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ textAlign: 'left', fontSize: '1.2em' }}>
        <p style={{ fontSize: '1.5em', fontWeight: 'bold', textAlign: 'center' }}>
          Ingreso a la plataforma de estímulos
        </p>
        <br />
        <p>
          Para ingresar completa los siguientes pasos:
        </p>
        <br />
        <p>
          1. Debe tener primero un usuario creado en el portal de Medellín: <a href="https://www.medellin.gov.co" target="_blank">www.medellin.gov.co</a>.
        </p>
        <p>
          2. Completar el perfil en <a href="https://www.medellin.gov.co/estimuloscultura/usuario/registrarUsuario" target="_blank">https://www.medellin.gov.co/estimuloscultura/usuario/registrarUsuario</a>.
        </p>
        <p>
          3. Ingresar <a href="https://www.medellin.gov.co/estimuloscultura/login" target="_blank">https://www.medellin.gov.co/estimuloscultura/login</a>. Con el mismo usuario y clave del portal.
        </p>
        <br />
        <p>
          Atentamente, <br />
          Equipo de Convocatorias de la Secretaría de Cultura Ciudadana
        </p>
      </div>
    </Modal>
  );
};
